import { useRegisterSidePanelSlot } from './context/SidePanelSlotContext';

import type { ReactElement } from 'react';

import styles from './scss/SidePanelSlot.module.scss';

/**
 * Marks where the free space splits for a screen's own side panels.
 *
 * Placed as a flex sibling of the page's main content, between it and the AI chat's own slot, so
 * an open panel's width sizes this box and the main content shrinks by the same amount for free.
 * Empty, it takes no space at all.
 */
function SidePanelSlot(): ReactElement {
  const setSlot = useRegisterSidePanelSlot();

  return <div ref={setSlot} className={styles.slot} />;
}

export default SidePanelSlot;
